import * as React from 'react';
import { Game } from './components/Game';

export function App() {
  return (
    <div className="App">
      <Game />
    </div>
  );
}

export default App;
